module.exports = __webpack_public_path__ + "static/img/main_ipaddress.7061aa26.png";